import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import { logoutUser } from '@/store/auth.store';

export const useLogout = () => {
  const router = useRouter();

  const handleLogout = useCallback(async () => {
    await logoutUser();
    router.push('/');
  }, [router]);

  return handleLogout;
};
